import { motion } from "framer-motion";
import { useContent } from "../../i18n/useContent";
import Icon from "../ui/Icons";
import Reveal, { RevealGroup, revealItemVariants } from "../ui/Reveal";
import "./Fleet.css";

export default function Fleet() {
  const { fleet, gallery } = useContent();

  return (
    <section id="flota" className="section section--alt">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">{fleet.eyebrow}</p>
          <h2 className="section-title">{fleet.title}</h2>
          <p className="section-lead">{fleet.lead}</p>
        </div>

        <RevealGroup className="fleet-gallery">
          {gallery.map((item) => (
            <motion.figure
              className={`fleet-gallery-item${item.big ? " fleet-gallery-item--big" : ""}`}
              variants={revealItemVariants}
              key={item.id}
            >
              <img src={item.src} alt={item.alt} loading="lazy" />
              <figcaption className="fleet-gallery-caption">{item.caption}</figcaption>
            </motion.figure>
          ))}
        </RevealGroup>

        <Reveal className="fleet-locations-head">
          <h3 className="fleet-locations-title">
            <Icon name="mapPin" size={18} />
            <span>{fleet.whereWeAre}</span>
          </h3>
        </Reveal>

        <RevealGroup className="fleet-locations" as="ul">
          {fleet.locations.map((loc) => (
            <motion.li className="fleet-location" variants={revealItemVariants} key={loc.id}>
              <span className="fleet-location-icon">
                <Icon name={loc.icon} size={20} />
              </span>
              <div>
                <h4 className="fleet-location-title">{loc.title}</h4>
                <address className="fleet-location-address">{loc.address}</address>
              </div>
            </motion.li>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
